import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconListAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconListAdd"><Path d="M11 19H3V17H11V19Z" fill="currentColor"/><Path d="M19 14H22V16H19V19H17V16H14V14H17V11H19V14Z" fill="currentColor"/><Path d="M11 13H3V11H11V13Z" fill="currentColor"/><Path d="M21 7H3V5H21V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconListAdd;
